import React from 'react'

import NonEmptyCartContextProvider from '../../../context/NonEmptyCartContextProvider'
import SharedBuyLayout from '../../../layouts/buy/SharedBuyLayout'
import Head from '../../../layouts/Head'
import BuyGlobalStyle from '../layout/BuyGlobalStyle'
import PaymentContainer from './PaymentContainer'
import RequiredCheckoutProgress from './RequiredCheckoutProgress'

const requiredSteps = ['shipping', 'delivery'] as const

export const PaymentPage: React.VFC = () => {
  return (
    <>
      <Head />
      <BuyGlobalStyle />
      <SharedBuyLayout>
        <NonEmptyCartContextProvider>
          <RequiredCheckoutProgress required={requiredSteps}>
            <PaymentContainer />
          </RequiredCheckoutProgress>
        </NonEmptyCartContextProvider>
      </SharedBuyLayout>
    </>
  )
}
